export default __webpack_public_path__ + "static/media/2.3584dbc1.png";